import React from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';

import { useTheme } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@material-ui/core/Box';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import * as math from '_core/utils/math';
import * as api from '_core/utils/api';


export default React.memo((props) => {
  const {
    langInfo,
    l,
    classes,
    
    period,
    setPeriod
  } = props;
  
  const [update, setUpdate] = React.useState(1);
  const [periods, setPeriods] = React.useState([]);
  
  React.useEffect(() => {
    api.getClassicPeriod()
      .then((list) => {
        if (!period && list.length)
          setPeriod(list[0]);
        
        setPeriods(list);
        setUpdate((update) => update + 1);
      })
      .catch((error) => {
        console.error(error);
        
        setPeriods([]);
      });
  }, []);
  
  
  return (
    <Box display="flex" justifyContent="flex-end">
      <Paper key={update} className={classes.filterPeriod} elevation={0}>
        <Select
          variant="outlined"
          fullWidth
          value={period?.id || 0}
          onChange={(event, value) => { const periodId = event.target.value; setPeriod(periods.find((period) => period.id === periodId) || period); }}
          label={l('$global.field.period')}
        >
          {periods.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {l(item.title)}
            </MenuItem>
          ))}
        </Select>
      </Paper>
    </Box>
  );
});
